// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"87f17073","977":"fa36b643"}[chunkId] + ".chunk.js";
};